import get from 'lodash/get';
import Me from '@models/Me';
import { callAnalytics } from '../actions/analytics';
import { analytics } from '../constants';

const skipLevel = (object) =>
  Object.values(object).reduce((acc, _value) => ({ ...acc, ..._value }), {});

const cache = new Map();

const handleAnalytics = (action, getState) => {
  let analyticsSchema;
  if (cache.has('schema')) analyticsSchema = cache.get('schema');
  else {
    cache.set('schema', JSON.parse(window?.analyticsSchema ?? '{}') ?? '{}');
    analyticsSchema = cache.get('schema');
  }
  const { entityName, itemId, data = {}, parentInfo } = action;
  // get all entites from analyticsSchema
  const analyticsData = get(skipLevel(analyticsSchema), entityName);
  // continue execution if analyticsData is defined
  if (typeof analyticsData === 'object') {
    const goalUid = get(getState(), 'auth.selectedGoal.uid');
    // get subscriptions info from store
    const plusSubscriptions = get(getState(), 'auth.me.plusSubscriptions', []);
    const plusSubscriptionUids = get(
      getState(),
      'auth.me.plusSubscriptionUids',
      []
    );
    let mappedData = {
      name: analyticsData.onclick.name,
      description: analyticsData.onclick.description
    }; // populating with name and description of an event
    if (typeof analyticsData.onclick.data === 'object')
      // get all properties of events(global + ) and update mappedData object
      mappedData = [
        ...Object.entries(analyticsData.onclick.data),
        ...Object.entries(analyticsSchema.global)
      ].reduce(
        (acc, [analyticsKey, value]) => {
          // to know if user is subscribed
          if (analyticsKey.toLowerCase().includes('is user subscribed')) {
            acc[analyticsKey] = plusSubscriptionUids.length > 0;
            return acc;
          }
          // days remaining in subscription
          if (
            analyticsKey
              .toLowerCase()
              .includes('days remaining in subscription')
          ) {
            acc[analyticsKey] = Math.round(
              Me.getDaysRemainingInSubscription(plusSubscriptions, goalUid) || 0
            );
            return acc;
          }
          // subscription end date
          if (analyticsKey.toLowerCase().includes('subscription duration')) {
            const { subscription } =
              Me.getSubscription(plusSubscriptions, goalUid) ?? {};
            acc[analyticsKey] = subscription?.duration ?? 0;
            return acc;
          }
          acc[analyticsKey] = get(data, value, '');
          if (
            acc[analyticsKey] &&
            analyticsKey.toLowerCase() === 'educator id' &&
            Array.isArray(acc[analyticsKey])
          ) {
            acc[analyticsKey] =
              acc[analyticsKey]?.map((item) => item.uid).join(',') ?? '';
          }
          if (
            acc[analyticsKey] &&
            analyticsKey.toLowerCase() === 'educator name' &&
            Array.isArray(acc[analyticsKey])
          ) {
            acc[analyticsKey] =
              acc[analyticsKey]?.map((item) => item.name).join(',') ?? '';
          }
          if (acc[analyticsKey] || typeof acc[analyticsKey] === 'boolean')
            return acc;
          let storeKey = value;
          if (itemId) {
            const storeKeys = storeKey.split('.');
            storeKey = [
              ...storeKeys.slice(0, storeKeys.length - 1),
              itemId,
              storeKeys[storeKeys.length - 1]
            ].join('.');
          }
          acc[analyticsKey] =
            get(getState(), storeKey) ?? get(getState(), value) ?? value;
          if (acc[analyticsKey] === value && value?.split('.')?.length > 1)
            acc[analyticsKey] = 'anonymous';
          return acc;
        },
        {
          ...mappedData,
          schema: true,
          'App Version': Number(process.env.APP_VERSION),
          'App Commit Id': process.env.APP_COMMIT_ID
        }
      );
    // add parentInfo to mappedData
    if (analyticsData.parent) {
      mappedData = { ...mappedData, ...parentInfo };
    }
    callAnalytics(mappedData, analyticsData.trackers);
  }
};

const analyticsMiddleWare = ({ dispatch, getState }) => (next) => (action) => {
  if (typeof action === 'function') {
    return action(dispatch, getState);
  }
  if (action.type === analytics.ANALYTICS && action.entityName) {
    return handleAnalytics(action, getState);
  }
  return next(action);
};

export default analyticsMiddleWare;
